<script setup lang="ts">
import { useNouveautesStore } from '../../stores/nouveautes';
import '../../styles/nouveautes.css';

/**
 * Lot BA, maquette « Dans l'appli » repère 1 : une version sort pendant que l'onglet est ouvert. Encart discret en bas
 * à gauche, rien ne se recharge tout seul (on peut finir ce qu'on tape).
 */
const store = useNouveautesStore();
</script>

<template>
  <!-- La zone annoncée par les lecteurs d'écran existe toujours (sans rôle, pour ne pas doubler les autres messages
       d'état de l'appli) ; l'encart, quand il apparaît, a le rôle « status ». -->
  <div class="nv-update-zone" aria-live="polite">
    <div v-if="store.offerVisible && store.offer" class="nv-update" role="status" data-testid="update-notice">
      <div class="nv-update-title">Nouvelle version {{ store.offer.version }}</div>
      <p class="nv-update-text">{{ store.offer.summary }}</p>
      <div class="nv-acts">
        <button
          class="btn sm primary"
          type="button"
          data-testid="update-refresh"
          :disabled="store.refreshing"
          @click="store.refresh()"
        >
          {{ store.refreshing ? 'Rafraîchissement…' : 'Rafraîchir' }}
        </button>
        <button class="btn sm nv-ghost" type="button" data-testid="update-later" @click="store.later()">
          Plus tard
        </button>
      </div>
    </div>
  </div>
</template>
